import React from 'react';
import { useSelector } from 'react-redux';
import { ORDER_LABELS } from '@src/containers/SpacesListing/constants';
import { useActions } from '@src/containers/SpacesListing/hooks';
import getOrderVariants from '@src/containers/SpacesListing/selectors/getOrderVariants';
import getSpacesListOrder from '@src/containers/SpacesListing/selectors/getSpacesListOrder';
import getSpaceSorterTitle from '@src/containers/SpacesListing/selectors/getSpaceSorterTitle';

import Sorter from '..';

const SorterCSpaces = () => {
	const title = useSelector(getSpaceSorterTitle);
	const sortOrder = useSelector(getSpacesListOrder);
	const orderLabel = ORDER_LABELS[sortOrder];
	const items = useSelector(getOrderVariants);
	const { setListOrder } = useActions();

	return title ? (
		<Sorter
			title={`${title}. `}
			sortOrder={orderLabel}
			items={items}
			onPopoverItemClick={({ id }) => {
				setListOrder({ order: id });
			}}
		/>
	) : null;
};

export default SorterCSpaces;
